import React from 'react'
import { ColorFormat } from 'modules/shares/types'
import { InspectorData } from 'modules/shares/Inspector/types'
import ArtboardSize from '../ArtboardSize'
import LayoutSettings from '../LayoutSettings'
import Overview from '../Overview'
import Exports from '../Exports'
import { VersionFragment } from 'gqlTypes'
import Box from 'components/Box'

// Types
interface ArtboardInfoProps {
  inspectorData: InspectorData
  onColorFormatChange: (f: ColorFormat) => void
  colorFormat: ColorFormat
  currentVersion: VersionFragment
  hasArtboardExportableAssets?: boolean
}

const ArtboardInfo: React.FC<ArtboardInfoProps> = ({
  inspectorData,
  colorFormat,
  onColorFormatChange,
  currentVersion,
  hasArtboardExportableAssets,
}) => {
  const isArtboard = !inspectorData.isPage && inspectorData.frame

  return (
    <>
      <Overview inspectorData={inspectorData} />

      {isArtboard && (
        <ArtboardSize
          artboardWidth={inspectorData.frame.width}
          artboardHeight={inspectorData.frame.height}
          color={inspectorData.background}
          colorVariables={inspectorData.colorVariables}
          onColorFormatChange={onColorFormatChange}
          colorFormat={colorFormat}
        />
      )}
      <LayoutSettings layout={{ ...inspectorData.layout }} />
      {isArtboard && (
        <Box marginTop="auto">
          <Exports
            for={{ type: 'artboard', value: inspectorData }}
            hasArtboardExportableAssets={hasArtboardExportableAssets}
            currentVersion={currentVersion}
          />
        </Box>
      )}
    </>
  )
}

export default ArtboardInfo
